import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Import migration dependencies
import { MigrationService } from './services/MigrationService';
import { StorageService } from './services/StorageService';
import { SettingsRepository } from './repositories/SettingsRepository';
import { GameAnalyticsIntegration } from './services/GameAnalyticsIntegration';

// Pre-initialize critical services before React starts
(async () => {
  try {
    // Run migration service to handle any data migrations
    const storageService = new StorageService();
    const settingsRepository = new SettingsRepository(storageService);
    const analytics = new GameAnalyticsIntegration();
    const migrationService = new MigrationService(settingsRepository, storageService, analytics);
    await migrationService.handleMigrations();
    
    // Load word packs into memory for synchronous access
    const { getAvailableWordPacks } = await import('./data/wordpacks');
    await getAvailableWordPacks();
    console.log('Word packs loaded and ready for synchronous access');
  } catch (error) {
    console.error('Failed to initialize app services:', error);
  }
})();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
